import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import i18next from "i18next";
import axios from "axios";
import PropTypes from "prop-types";
import { Dialog, Button, Image } from "hesus-ui-kit";
import ClipLoader from "react-spinners/ClipLoader";
import { useGetMainCurrencyByCountryId } from "@hooks/useGeneralParams";
import closeIcon from "@icons/ic-close-white.svg";
import Trucks from "../../../AddEditWarehouse/components/Trucks/Trucks";
import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  ButtonInnerWrapper,
  FormBody,
  SectionContainer,
  OuterWrapper,
  FlexRow,
} from "../../../AddEditWarehouse/AddEditWarehouse.styled";
import "../../../AddEditWarehouse/AddEditWarehouse.scss";

const AddEditTrucks = (props) => {
  const {
    t,
    onClose,
    trucks,
    warehouseData,
    updateWarehouseRefeshStatus,
    companyId,
    carrierId,
    countryId,
  } = props;

  const [isWarehouseCreating, setIsWarehouseCreating] = useState(false);
  const [warehouseAPIError, setCreateWarehouseAPIError] = useState("");
  const mainCurrency = useGetMainCurrencyByCountryId(countryId);
  const [isRequired, setIsRequired] = useState([{ requiredStatus: false }]);
  const [inputList, setInputList] = useState([
    {
      id: "",
      status: true,
      transportType: "",
      count: "",
      price: "",
      currency: mainCurrency,
      unit: "",
    },
  ]);

  const [inputListError, setInputListError] = useState([
    {
      transportTypeError: "",
      countError: "",
      priceError: "",
      currencyError: "",
      unitError: "",
    },
  ]);

  useEffect(() => {
    if (trucks.length > 0) {
      const truckList = Object.entries(trucks).map((truck) => {
        return {
          id: truck[1].id,
          status: truck[1].status,
          count: truck[1].count,
          price: truck[1].price,
          currency: truck[1]?.currency?.id,
          unit: truck[1].unit,
          transportType: {
            value: truck[1]?.truckType?.id,
            label: truck[1]?.truckType?.name,
          },
        };
      });
      setInputList(truckList);

      const truckListError = Object.entries(trucks).map((truck) => {
        return {
          transportTypeError: "",
          countError: "",
          priceError: "",
          currencyError: "",
          unitError: "",
        };
      });
      setInputListError(truckListError);

      const requiredStatus = Object.entries(trucks).map((truck) => {
        return {
          requiredStatus: true,
        };
      });
      setIsRequired(requiredStatus);
    }
  }, []);

  const validateForm = (inputList, inputListError) => {
    let isFormValid = true;
    const listError = [...inputListError];
    if (inputList.length > 0) {
      inputList.map((x, index) => {
        if (
          x.status === true &&
          (x.count === "" ||
            x.currency === "" ||
            x.price === "" ||
            x.transportType === "" ||
            x.unit === "")
        ) {
          isFormValid = false;

          if (x.count === "") {
            const name = "countError";
            listError[index][name] = t("FIELD_REQUIRED");
          }
          if (x.transportType === "") {
            const name = "transportTypeError";
            listError[index][name] = t("FIELD_REQUIRED");
          }
          if (x.currency === "") {
            const name = "currencyError";
            listError[index][name] = t("FIELD_REQUIRED");
          }
          if (x.price === "") {
            const name = "priceError";
            listError[index][name] = t("FIELD_REQUIRED");
          }
          if (x.unit === "") {
            const name = "unitError";
            listError[index][name] = t("FIELD_REQUIRED");
          }
        }
      });
      setInputListError(listError);
    }
    return isFormValid;
  };

  const getFormData = () => {
    let truckData = [];
    if (inputList.length > 0) {
      inputList.map((transport) => {
        truckData.push({
          id: transport.id,
          truckType: {
            id: transport?.transportType?.value,
            name: transport?.transportType?.label,
          },
          count: transport.count,
          currency: { id: transport.currency },
          price: transport.price,
          unit: transport.unit,
          status: transport.status,
        });
      });
    }
    const data = {
      id: warehouseData.id,
      name: warehouseData.name,
      phone: warehouseData.phone,
      status: warehouseData.status,
      address: {
        address: warehouseData.address.street,
        zipcode: warehouseData.address.postalCode,
        city: warehouseData.address.city,
        country: warehouseData.address.country,
        position: {
          latitude: warehouseData.address.position.latitude,
          longitude: warehouseData.address.position.longitude,
        },
      },
      trucks: truckData,
    };
    return data;
  };

  const onSubmit = () => {
    const isFormValid = validateForm(inputList, inputListError);
    if (isFormValid) {
      setIsWarehouseCreating(true);
      setCreateWarehouseAPIError("");
      axios
        .put(
          `/companies/${companyId}/hauliers/${carrierId}/warehouses/${warehouseData.id}`,
          getFormData()
        )
        .then((response) => {
          setIsWarehouseCreating(false);
          updateWarehouseRefeshStatus();
          onClose();
        })
        .catch((error) => {
          setIsWarehouseCreating(false);
          setCreateWarehouseAPIError(error.response?.data?.message ?? "");
        });
    }
  };

  return (
    <Dialog>
      <div>
        <HeaderWrapper>
          <Title>{warehouseData.name + " " + t("WAREHOUSE_TRUCKS")}</Title>
          <Button
            onClick={onClose}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image src={closeIcon} alt="close Analytical Note price popup" />
          </Button>
        </HeaderWrapper>
        <FormBody>
          <OuterWrapper>
            <FlexRow>
              <SectionContainer>
                <Trucks
                  inputList={inputList}
                  setInputList={setInputList}
                  inputListError={inputListError}
                  setInputListError={setInputListError}
                  isRequired={isRequired}
                  setIsRequired={setIsRequired}
                  countryId={countryId}
                  mainCurrency={mainCurrency}
                />
              </SectionContainer>
            </FlexRow>
          </OuterWrapper>
        </FormBody>
        <ButtonWrapper marginTop="-1rem">
          <ButtonInnerWrapper>
            <Button
              styles={{
                color: "white",
                background: "#1BACE4",
                border: "1px solid #1BACE4",
                marginRight: "0.32rem",
                "&:hover": {
                  backgroundColor: "#1589b6",
                },
              }}
              onClick={onSubmit}
            >
              <>
                {isWarehouseCreating && <ClipLoader size={15} color="#fff" />}
                {!isWarehouseCreating && t("VALIDATE")}
              </>
            </Button>
            <Button
              styles={{
                color: "#333",
                background: "#fff",
                border: "1px solid #ccc",
                "&:hover": {
                  backgroundColor: "#ccc",
                },
              }}
              onClick={onClose}
            >
              {t("CLOSE")}
            </Button>
          </ButtonInnerWrapper>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

AddEditTrucks.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
};
AddEditTrucks.defaultProps = {
  id: null,
};

export default withTranslation()(AddEditTrucks);
